import { render, staticRenderFns } from "./GetTelegramAccountDetails.vue?vue&type=template&id=7fb01fde"
import script from "./GetTelegramAccountDetails.vue?vue&type=script&lang=js"
export * from "./GetTelegramAccountDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports